<div class="flex flex-col gap-3">
  <div class="flex items-center justify-between gap-3">
    <div class="min-w-0">
      <p class="m-0 text-sm font-medium text-primary">Active</p>
      <p class="m-0 mt-0.5 text-xs text-secondary">
        When on, this message is sent in chat when a creator is hired.
      </p>
    </div>
    <button
      type="button"
      role="switch"
      [attr.aria-checked]="enabled()"
      [attr.aria-label]="enabled() ? 'Hire message active' : 'Hire message inactive'"
      [disabled]="readonly()"
      (click)="onEnabledToggle()"
      class="relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary disabled:cursor-not-allowed disabled:opacity-50"
      [class]="enabled() ? 'bg-primary' : 'bg-gray-300 dark:bg-zinc-600'">
      <span
        class="inline-block size-5 rounded-full bg-white shadow transition-transform"
        [class]="enabled() ? 'translate-x-5' : 'translate-x-0.5'"></span>
    </button>
  </div>

  <div class="flex flex-wrap items-center justify-between gap-2">
    <label for="hire-message-body" class="block text-xs font-medium text-primary">
      Message
    </label>
    @if (!readonly()) {
    <button
      type="button"
      (mousedown)="insertFirstNameToken($event)"
      class="inline-flex items-center rounded-full border border-gray-300 dark:border-zinc-600 bg-gray-50 dark:bg-zinc-800 px-2.5 py-1 text-xs font-medium text-primary hover:bg-gray-100 dark:hover:bg-zinc-700">
      + First name
    </button>
    }
  </div>

  <textarea
    #messageInput
    id="hire-message-body"
    rows="5"
    [value]="message()"
    [readOnly]="readonly()"
    (input)="onMessageInput($event)"
    placeholder="Hi {{ firstNameToken }}, congratulations — you've been hired..."
    class="w-full rounded-md border border-gray-300 dark:border-zinc-600 bg-white dark:bg-zinc-900 px-3 py-2 text-sm text-primary disabled:opacity-60 read-only:bg-gray-50 dark:read-only:bg-zinc-800"></textarea>

  <p class="m-0 text-xs text-secondary">
    Use
    @if (!readonly()) {
    <button
      type="button"
      (mousedown)="insertFirstNameToken($event)"
      class="inline rounded bg-gray-100 dark:bg-zinc-800 px-1 font-mono text-xs text-primary hover:bg-gray-200 dark:hover:bg-zinc-700"
      [attr.aria-label]="'Insert ' + firstNameToken">
      {{ firstNameToken }}
    </button>
    } @else {
    <code class="rounded bg-gray-100 dark:bg-zinc-800 px-1">{{ firstNameToken }}</code>
    }
    for the creator&apos;s first name.
  </p>
</div>
